__turbopack_context__.v({
  "card": "popovermenu-module-scss-module__XJdM3G__card",
  "fullSize": "popovermenu-module-scss-module__XJdM3G__fullSize",
  "linkSetWrapper": "popovermenu-module-scss-module__XJdM3G__linkSetWrapper",
  "mainHeading": "popovermenu-module-scss-module__XJdM3G__mainHeading",
  "show": "popovermenu-module-scss-module__XJdM3G__show",
});
